<template>
    <h3 class="my-1" v-if="variant==='text'">{{ label }}</h3>
    <h3 v-else></h3>
</template>
<script >
import {defineComponent} from "@vue/composition-api"
export default defineComponent({
  name: "WidgetDivider",
  props: {
    variant: String,
    label:String
  }
})
</script>